module.exports = __webpack_public_path__ + "img/0S6A9514 copia.7acd342a.jpg";